/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PostCategoryDetailResponse } from '../../models/post-category-detail-response';

export interface GetPostCategory$Params {
  id: number;
}

export function getPostCategory(http: HttpClient, rootUrl: string, params: GetPostCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<PostCategoryDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getPostCategory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PostCategoryDetailResponse>;
    })
  );
}

getPostCategory.PATH = '/api/post/category/{id}';
